import { Row } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';

function SecondaryPagesBanner(props) {

  return (
    <>
      <Col className='mainBlock' md={12}>
        <Row>
          <div>
            <h2 style={{ textAlign: 'center', marginTop: '10px'  }}>{props.header}</h2>
          </div>
          <div>
            <h4 style={{textAlign: 'center', fontSize: '18px', fontWeight:'900', paddingLeft:'10%', paddingRight:'10%', color: 'rgba(40, 79, 170, 0.70)'}}>
            {props.subheader}
            </h4>
          </div>
          <div className='mainBlockText' style={props.customStyle}>
            {props.text}
          </div>
        </Row>
      </Col>
    </>
  )
}

export default SecondaryPagesBanner;